import { AxiosResponse } from 'axios';
import { call, CallEffect, PutEffect, select } from 'redux-saga/effects';

import { Action } from 'redux-saga';
import { ReducersTypes } from '@/redux/reducers/Models';
import { automaticApi } from '@/settings/api';
import { clearString } from '@/utils/functions';
import moment from 'moment';

export interface Fetch {
    data: {
        brandName?: string;
        modelName?: string;
    };
    callback: (success: boolean, data: { orderId?: string; errorMessage?: string }) => void;
}

export interface CreateUserAction {
    type: string;
    payload: Fetch;
}

const uri = '/pedido/v1/iniciarAdesao'

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* createUser({
    payload,
}: CreateUserAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomerReducer);
        const register = customer?.register;
        const address = register?.address;
        const vehicle = register?.vehicle;

        const body = {
            identificadorStatus: 10,
            pin: register?.pin,
            hashPin: register?.hashCode,
            nome: register?.name,
            cpfCnpj: clearString(register?.document!),
            numeroCelular: clearString(register?.phone!),
            email: register?.email,
            dataNascimento: moment().format('YYYY-MM-DD'),
            ...(register?.razaoSocial ? { razaoSocial: register.razaoSocial } : {}),
            endereco: {
                cep: clearString(address?.zipcode!),
                logradouro: address?.streetName,
                numero: address?.number,
                complemento: address?.complement ?? "-",
                bairro: address?.neighborhood,
                cidade: address?.city,
                estado: address?.state,
            },
            veiculo: {      
                fabricante: payload.data.brandName,
                modelo: payload.data.modelName,
                placa: clearString(vehicle?.plate!).toUpperCase(),
                tipoVeiculo: Number(vehicle?.type),
                anoModelo: "2000",
                hashPlaca: vehicle?.plateCode,
            }
        }

        const response: AxiosResponse = yield call(automaticApi.post, uri, body)
        const responseData = response?.data;

        if (responseData?.status?.codigoRetorno === 0) {
            
            yield call(
                payload.callback, 
                true, 
                {
                    orderId: responseData?.dados?.pedido
                }
            );

        } else {
            yield call(
                payload.callback, 
                false,
                {
                    errorMessage: responseData?.status?.mensagem === "Cliente já cadastrado" ? "already" : "timeout"
                }
            );
        }
    } catch (err) {
        yield call(
            payload.callback, 
            false,
            {
                errorMessage: "timeout"
            }
        );
    }
}
